/* eslint jsx-a11y/label-has-associated-control: 0 */
/* eslint max-len: 0 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import translationKeys from 'translations/translationKeys';
import { verifyTicket } from 'redux/verify-ticket/verifyTicketSlice';
import themeAssets from 'assets/theme-assets';

const HeaderVerifyTicket = () => {
  const assets = themeAssets[process.env.REACT_APP_THEME_NAME];
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { agentId } = useSelector((store) => store.login);
  const { isTicketLoading } = useSelector((store) => store.ticketData);
  const [ticketRef, setTicketRef] = useState('');
  const { msg71 } = translationKeys;

  const handleChange = (e) => {
    setTicketRef(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const ticketNumber = ticketRef.split('#')[0];
    if (!ticketNumber) return;

    localStorage.setItem('ticketNumber', ticketNumber);
    localStorage.setItem('payRefCode', `%5B%22${ticketNumber}%22%5D`);
    dispatch(verifyTicket({ refCode: ticketNumber, agentId }));
    setTicketRef('');
  };

  return (
    <form className="header-verify-ticket" onSubmit={handleSubmit}>
      <div className="input-group">
        <span className="icon" style={{ maskImage: `url(${assets.checkTicket})` }} />
        <input
          type="text"
          className="form-control"
          id="headerTicketNumber"
          placeholder={t(msg71)}
          value={ticketRef}
          onChange={handleChange}
          required
        />
      </div>
      <button
        type="submit"
        className="btn btn-secondary"
        disabled={!ticketRef || isTicketLoading}
        aria-label={t(msg71)}
      >
        {isTicketLoading ? (
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
        ) : (
          <img src={assets.search} alt="search" />
        )}
      </button>
    </form>
  );
};

export default HeaderVerifyTicket;
